import axios from "axios";
import { database } from "../../config/firebase";
import { selectHighestPregunta } from "../selectors/actividades";

const API_KEY = process.env.REACT_APP_BACKEND_URL;

export const getFirebaseData = () => (dispatch, getState) => {
  database
    .ref()
    .child("/")
    .once("value", snapshot => {
      const allEntities = snapshot.val();
      let normalized = {};
      Object.keys(
        allEntities || {
          preguntas: {},
          respuestas: {},
          users: {},
          groups: {},
          viajes: {}
        }
        // eslint-disable-next-line array-callback-return
      ).map(key => {
        normalized = {
          ...normalized,
          [key]: {
            ...normalized[key],
            byId: allEntities[key],
            allIds: Object.keys(allEntities[key])
          }
        };
      });

      dispatch({
        type: "FETCHED_FIREBASE_ENTITIES",
        payload: snapshot.val()
      });
    });
};

// TODO: Needs to extend functionality for db users
export const deleteAllUsers = () => () => {
  axios.delete(`${API_KEY}/auth/deleteAllUsers`);
};

export const deleteUser = key => dispatch => {
  axios
    .post(`${API_KEY}/auth/deleteUser`, {
      delete: {
        uid: key
      }
    })
    .then(() => {
      const ref = database
        .ref()
        .child("users")
        .child(key);
      ref.remove();
      dispatch({ type: "DELETED_USER", payload: key });
    });
};
